import "./NavButton.css";

// prev and next button
const NavButton = ({ currentIndex, setCurrentIndex, currentList }) => {
  return (
    <div className="NavButton__container">
      <button
        onClick={(event) => {
          event.preventDefault(); // Prevent default behavior
          setCurrentIndex(Math.max(currentIndex - 1, 0)); // Update state
        }}
        disabled={currentIndex === 0}
        className={`NavButton__button ${
          currentIndex === 0
            ? "NavButton__button--disabled"
            : "NavButton__button--enabled"
        }`}
      >
        {"<"}
      </button>
      <button
        onClick={(event) => {
          event.preventDefault();
          setCurrentIndex(Math.min(currentIndex + 1, currentList.length - 1));
        }}
        disabled={currentIndex === currentList.length - 1}
        className={`NavButton__button ${
          currentIndex === currentList.length - 1
            ? "NavButton__button--disabled"
            : "NavButton__button--enabled"
        }`}
      >
        {">"}
      </button>
    </div>
  );
};
export default NavButton;
